import React from 'react';

import {Spin} from 'client/common/components/lego';
import {checkPayed} from 'client/common/utils/payment';

import {useCreativeSettingsProps} from './utils';
import CreativeSettingsView from './creative-settings-view';

export default function CreativeSettings() {
    const {
        slug,
        survey,
        canEdit,
        stat,
        creative,
        additionalParameters,
        brand,
        industry,
        targeting,
        paymentStatus
    } = useCreativeSettingsProps();

    if (survey.status === 'loading') {
        return <Spin position='center' size='m' view='default' progress />;
    }

    return (
        <CreativeSettingsView
            slug={slug}
            survey={survey?.data}
            stat={stat}
            creative={creative}
            additionalParameters={additionalParameters}
            brand={brand}
            industry={industry}
            targeting={targeting}
            canEdit={canEdit}
            isPayed={checkPayed(paymentStatus.data)}
        />
    );
}
